<div class="w-100 h-100 image-container">
  <img [src]="data" (click)="closeDialog()" />
</div>
